'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Footer = require('./Footer.css');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = (_dec = (0, _reactCssModules2.default)(_Footer2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var iyvLogo = require('../../../static/images/iyv-logo-project-of-2021.jpg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.IyvBanner, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'iyv-logo-above-form' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.ays,
                title: 'As You Sow'
              },
              _react2.default.createElement('img', {
                src: iyvLogo,
                alt: 'As You Sow'
              }),
              _react2.default.createElement(
                _components.SrOnly,
                null,
                'As You Sow'
              )
            )
          ),
          _react2.default.createElement(_components.SignupForm, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'af-img-bckgrnd' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'af-row1' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: '/about',
                          title: 'About us'
                        },
                        'Invest your values'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'We offer sustainable investment tools that highlight issues dealing with climate change, gender equality and more'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.about,
                          title: 'About Invest Your Values',
                          transparentbutton: true
                        },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'nowrap' },
                          'About us',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.donate,
                          title: 'Support this work'
                        },
                        'Support this work'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'Invest Your Values is funded by contributions to ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'As You Sow'
                      ),
                      ', a ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'non-profit 501(c)3'
                      ),
                      '.'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.donate,
                          title: 'Donate to As You Sow',
                          transparentdonatebutton: true
                        },
                        'Donate',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.ays,
                          title: 'As You Sow'
                        },
                        _react2.default.createElement('img', {
                          src: aysLogo,
                          alt: 'As You Sow',
                          styleName: 'af-logo'
                        }),
                        _react2.default.createElement(
                          _components.SrOnly,
                          null,
                          'As You Sow'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'Invest Your Values  is a project by ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      ', a 501(c)3 nonprofit empowering shareholders to change corporations for good'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.ays,
                          title: 'As You Sow',
                          transparentbutton: true
                        },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'nowrap' },
                          'Visit As You Sow',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'af-row2' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 8 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-hl' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.legal,
                        title: 'Legal'
                      },
                      'Legal'
                    ),
                    ' \xA0\xA0\xA0'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-p' },
                    '\xA9 Copyright ',
                    new Date().getFullYear(),
                    ' As You Sow. All rights reserved.',
                    _react2.default.createElement('br', null),
                    'Main Post Office, PO Box 751, Berkeley, CA 94701'
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'p',
                    { styleName: 'af-col-hl' },
                    _react2.default.createElement(
                      'i',
                      null,
                      'Connect with As You Sow'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'af-col-p' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.contact,
                        title: 'Contact us'
                      },
                      'Contact us'
                    ),
                    '\xA0\xA0\xA0',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.socialAYStwitter,
                        title: 'Connect with us on Twitter',
                        xstrong: true
                      },
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-twitter' })
                    ),
                    '\xA0\xA0\xA0',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.socialAYSfb,
                        title: 'Connect with us on Facebook',
                        xstrong: true
                      },
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-facebook-official' })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Footer;
}(_react.Component)) || _class);
exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Footer/Footer.js
// module id = 1433
// module chunks = 0